<template>
  <v-card
    v-bind="$attrs"
    tile
    class="mb-2 px-4 pt-2 pb-1"
    :elevation="elevation"
    v-on="$listeners"
  >
    <v-row no-gutters>
      <v-col>
        <v-row no-gutters>
          <v-col class="d-flex align-center">
            <template v-if="bus.from">
              <span class="subtitle-1 font-weight-bold mr-2">{{
                bus.from
              }}</span>
              <v-icon size="22" color="black" class="mr-2"
                >mdi-arrow-right</v-icon
              >
            </template>
            <span class="subtitle-1 font-weight-bold">{{ bus.to }}</span>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col class="body-2 grey--text text--darken-1">
            {{ bus.via.length ? `Via ${places}` : 'Direkt' }}
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col>
            <div class="caption mt-2" :class="$style.busTypeContainer">
              {{ orderTypeKind[bus.type] }}
              <strong v-if="bus.type === 'Replacement'">{{ bus.train }}</strong>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="auto"
        v-if="$slots.default"
        class="d-flex flex-column align-end pl-4"
      >
        <slot />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
const orderTypeKind = {
  Replacement: 'Tågersättning',
  Shuttle: 'Pendel'
}

export default {
  name: 'OverviewListItem',

  props: {
    showViaPlaces: {
      type: Boolean,
      default: () => true
    },
    elevation: {
      type: [String, Number],
      default: () => 1
    },
    bus: Object
  },

  data: () => ({
    orderTypeKind
  }),

  computed: {
    places() {
      return this.showViaPlaces ? this.bus.via.join(', ') : ''
    }
  }
}
</script>

<style module>
.busTypeContainer {
  background: #ededed;
  border-top-right-radius: 99px;
  border-bottom-right-radius: 99px;
  margin-left: -16px;
  padding: 2px 16px;
  width: 180px;
}
</style>
